export const getTeamList = state => {
    return state.list
}

export const getTeamDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/teamList/getters.js